<template>
  <ProSpaceGeoLayout>
    <template #top>
      <ProSpaceTopPanel :header="this.$t('orders')">
        <template #right>
          <ProSpaceIconButton
            icon="update"
            iconWidth="16px"
            iconHeight="16px"
            containerSize="20px"
            @click="actionUpdate"
          />
<!--          <ProSpaceButton
            type="primary"
            icon="plus"
            :label="this.$t('newTxt')"
            @click="showChangeModal"
          /> Task #333850-->
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout>
        <template #top>
          <ProSpaceFilterPanel
            :searchPlaceholder="$t('searchTxt')"
            :modelFastFilter="modelFastFilter"
            :fastFilters="fastFilters"
            :txtResetFilters="$t('txtResetFilters')"
            :unicKeyStorage="orderService.constructor.name + 'grid'"
            @apply="submitFilter"
            ref="filterPanel"
            filter-model="agencyValue"
            @update:modelFastFilter="
              (val) => {
                modelFastFilter = val;
              }
            "
          >
            <template #hint>
              {{ this.$t("filterBy") }}
            </template>
            <template #filters="{ filter }">
              <ProSpaceMultiSelect
                v-model="filter.marsPeriodId"
                :service="marsPeriodService"
                get-method="grid"
                option-label="name"
                option-value="id"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('resetTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :placeholder-value="$t('marsPeriod')"
                @apply="(model) => customFilterApply(filter, model)"
                :default-filter="{
                  disabled: false,
                }"
              />
              <ProSpaceMultiSelect
                :localization="$t"
                v-model="filter.status"
                :service="orderStatusService"
                getMethod="get"
                optionLabel="text"
                optionValue="status"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :placeholderValue="$t('status')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('resetTxt')"
                @apply="(model) => customFilterApply(filter, model)"
              />
              <ProSpaceCustomFilterPanel
                :customTxt="$t('custom')"
                :customFilterTxt="$t('customFilterTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('resetTxt')"
                :fromTxt="$t('fromTxt')"
                :toTxt="$t('toTxt')"
                :services="customServices"
                :unicKeyStorage="orderService.constructor.name + 'grid'"
                @apply="(model) => customFilterApply(filter, model)"
              />
            </template>
          </ProSpaceFilterPanel>
        </template>
        <template #center>
          <ProSpaceMainGrid
            ref="grid"
            getMethod="grid"
            selectionMode="single"
            :service="orderService"
            :noMountedRequest="true"
            @selected-change="selectedHandler"
          >
            <template #columns>
              <Column
                field="status"
                :header="this.$t('orderMarsPeriodName')"
                sortable
                headerClass="move-sort-head"
              >
                <template #body="field">
                  <ProSpaceTableHeaderCell
                    v-if="field.data"
                    :id="field.data.id"
                    :status="getStatus(field.data.status)"
                    :title="field.data.marsPeriodName"
                    @click-on-title="editItem(field.data)"
                  />
                </template>
              </Column>
              <Column
                field="agencyValue"
                :header="$t('orderAgencyValue')"
                sortable
              >
                <template #body="field">
                  <ProSpaceDefaultTextColumn>
                    {{ field.data.agencyValue }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>

              <Column field="actions" class="column-end column-end-30">
                <template #body="field">
                  <ProSpaceDots
                    :options="dotsOptions"
                    @action="(action) => handleDots(action, field.data)"
                  ></ProSpaceDots>
                </template>
              </Column>
            </template>
            <template #empty>
              <ProSpaceEmptyGrid
                icon="error-message"
                :title="$t('noDataTitle')"
                :text="$t('noDataTxt')"
              />
            </template>
          </ProSpaceMainGrid>
        </template>
      </ProSpaceGeoLayout>
      <ProSpaceModal
        v-model="showModal"
        width="410"
        :disabledApply="false"
        :title="isEdit ? $t('editItemTxt') : $t('createItemTxt')"
        :icon="isEdit ? 'edit' : 'plus'"
        @apply="changeItem"
        :cancelTxt="$t('cancelTxt')"
        :applyTxt="$t('applyTxt')"
      >
        <ProSpaceVLayout :gap="20">
          <ProSpaceDropdown
            v-model="modalModel.marsPeriodId"
            ref="marsPeriodId-ProSpaceDropdown"
            :label="$t('orderMarsPeriodId')"
            :placeholder="$t('orderMarsPeriodName')"
            :service="marsPeriodService"
            getMethod="grid"
            propValue="id"
            propLabel="name"
            argMethod="$filter=disabled eq false"
            @change="(item) => (modalModel.marsPeriodName = item?.name)"
          />
          <ProSpaceDropdown
            v-model="modalModel.agencyId"
            ref="agencyId-ProSpaceDropdown"
            :label="$t('orderAgencyId')"
            :placeholder="$t('orderAgencyValue')"
            :service="agencyService"
            getMethod="grid"
            propValue="id"
            propLabel="value"
            argMethod="$filter=disabled eq false"
            @change="(item) => (modalModel.agencyValue = item?.value)"
          />
          <ProSpaceInputText
            v-model="modalModel.status"
            :label="$t('orderStatus')"
            :placeholder="$t('orderStatus')"
          />
        </ProSpaceVLayout>
      </ProSpaceModal>
      <OrderModalImport
        v-model="showImportModal"
        @loading="loadingHandler"
        accept=".csv, .xlsx"
      />
      <ProSpaceHistoryModal
        ref="history"
        v-model="showHistoryModal"
        modelName="OrderApiModel"
        @close="closeHistory"
      />
    </template>
    <template #right>
      <OrderPanel
        v-if="selectedModel"
        ref="right-panel"
        :service="orderService"
        :model="selectedModel"
        :options="dotsOptions"
        @edit="editItem"
        @delete="deleteItem"
        @history="showHistory"
      />
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceFilterPanel,
  ProSpaceCustomFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceMainGrid,
  ProSpaceDots,
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceIconButton,
  ProSpaceButton,
  ProSpaceTableHeaderCell,
  ProSpaceDateColumn,
  ProSpaceDefaultTextColumn,
  ProSpaceEmptyGrid,
  ProSpaceLeftPanel,
  ProSpaceTree,
  ProSpaceVLayout,
  ProSpaceFilterContainsChips,
  ProSpaceFilterDatesRange,
  ProSpaceDropdown,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceInputSwitch,
  ProSpaceInputText,
  ProSpaceFlashMessage
} from "@prospace/prospace-components-library";
import { OrderService } from "../../services/OrderService.js";
import { MarsPeriodService } from "../../services/MarsPeriodService.js";
import { AgencyService } from "../../services/AgencyService.js";
import { OrderStatusService } from "../../services/OrderStatusService.js";

import Column from "primevue/column";
import OrderPanel from "./components/OrderPanel";
import ProSpaceHistoryModal from "../../../../../Frontends/ProSpace/components/modals/ProSpaceHistoryModal.vue";
import OrderModalImport from "./components/OrderModalImport";
const _ = require("lodash");
import { mapGetters } from "vuex";

export default {
  components: {
    ProSpaceFilterPanel,
    ProSpaceCustomFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceMainGrid,
    ProSpaceDots,
    ProSpaceModal,
    Column,
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceIconButton,
    ProSpaceButton,
    ProSpaceTableHeaderCell,
    ProSpaceDateColumn,
    ProSpaceDefaultTextColumn,
    ProSpaceEmptyGrid,
    OrderPanel,
    ProSpaceHistoryModal,
    ProSpaceLeftPanel,
    ProSpaceTree,
    ProSpaceVLayout,
    ProSpaceFilterContainsChips,
    ProSpaceFilterDatesRange,
    ProSpaceDropdown,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceInputSwitch,
    ProSpaceInputText,
    OrderModalImport,
    ProSpaceFlashMessage
  },
  data() {
    return {
      showModal: false,
      showImportModal: false,
      showHistoryModal: false,
      // Grid Panel
      selectedModel: null,
      spKey: 0,
      spHide: false,

      // Service
      orderService: new OrderService(),
      marsPeriodService: new MarsPeriodService(),
      agencyService: new AgencyService(),
      orderStatusService: new OrderStatusService(),

      //InlinePanel
      masterId: null,
      isEdit: false,
      isCreate: false,
      modalModel: {},

      // Multi filter
      modelFastFilter: {
        label: this.$t("allTxt"),
        value: false,
        field: "disabled",
      },
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
    }),
    customServices() {
      return [
        {
          type: "chips",
          model: "createdBy",
          label: this.$t("createdByTxt"),
          selected: {},
        },
        {
          type: "chips",
          model: "updatedBy",
          label: this.$t("updatedByTxt"),
          selected: {},
        },
        {
          type: "dates-range-time",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
        {
          type: "dates-range-time",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
      ];
    },
    dotsHeaderOptions() {
      return [
        { name: "export_xlsx", text: this.$t("export_xlsx"), icon: "download" },
      ];
    },
    dotsOptions() {
      let res = [
        /*{
          name: "edit",
          text: this.$t("editItemTxt"),
          icon: "edit",
          method: this.editItem,
        },
        {
          name: "delete",
          text: this.$t("delete"),
          icon: "delete",
          method: this.deleteItem,
        }, Task #333850*/
        {
          name: "showHistory",
          text: this.$t("history"),
          icon: "history",
          method: this.showHistory,
        },
      ];
      if (this.modelFastFilter.label === this.$t("deleted")) {
        res = res.filter(
          (option) => option.name !== "edit" && option.name !== "delete"
        );
      }
      return res;
    },
    fastFilters() {
      return [
        { label: this.$t("allTxt"), field: "disabled", value: false },
        { label: this.$t("deleted"), field: "disabled", value: true },
      ];
    },
  },
  methods: {
    closeHistory() {
      this.showHistoryModal = false;
    },
    showHistory(record) {
      this.$refs.history.tabs[0].masterId = record.id;
      this.$refs.history.masterName = record.code;
      this.$nextTick(() => {
        this.showHistoryModal = true;
      });
    },
    toItem(data) {
      this.$router.push(`/addressprogram/order/${data.id}`);
    },
    submitFilter({ filter, search }) {
      this.$refs.grid.submitFilter(filter, search);
    },
    emitFilter() {
      this.$refs.filterPanel.submitFilter();
    },
    customFilterApply(filter, model) {
      filter = Object.assign(filter, model);
      this.$refs.filterPanel.submitFilter();
    },
    actionUpdate() {
      this.$refs.grid.getRecords(true);
      if (this.$refs["right-panel"]) {
        this.$refs["right-panel"].update();
      }
    },
    actionExport(format) {
      this.loadingHandler(true);
      this.orderService
        .export(this.grid.getRecords(false, true), format)
        .then(() => this.loadingHandler(false));
      //TODO: Catch error?
      //TODO: Show message(export task created)
    },
    actionImport() {
      this.showImportModal = true;
    },
    loadingHandler(val) {
      this.$refs.grid.loading = val;
    },
    selectedHandler({ data: val}) {
      const id = val.id;

      if (!id) {
        this.selectedModel = null;
      } else {
        this.selectedModel = id;
        this.masterId = id;
      }
    },
    showChangeModal() {
      this.isEdit = false;
      this.isCreate = true;
      this.modalModel = {};
      this.showModal = true;
    },
    clear() {
      if (this.$refs.grid) {
        this.selectedModel = null;
        this.$refs.grid.selectedModel = [];
        this.$refs.grid.clickedItem = null;
        this.$refs.grid.isAllRowsSelected = false;
      }
    },
    editItem(model) {
      if (!model) return;
      this.isEdit = true;
      this.isCreate = false;
      this.modalModel = _.cloneDeep(model);
      this.showModal = true;
    },
    changeItem() {
      let method;
      if (this.isCreate) {
        method = "create";
      }
      if (this.isEdit) {
        method = "update";
      }
      this.orderService[method](this.modalModel).then(() => {
        this.actionUpdate();
      });
    },
    deleteItem(model) {
      if (!model) return;
      this.orderService.delete(model).then(() => {
        this.actionUpdate();
        this.selectedModel = {};
      });
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    handleDots(action, item) {
      var option = this.dotsOptions.find((o) => o.name === action);
      option.method(item);
    },
    handleHeaderDots(action) {
      switch (action) {
        case "export_xlsx":
          this.actionExport("XLSX");
          break;
      }
    },
  },
};
</script>
<style lang="scss"></style>
